const ROUTES_PATH = {
  LOG_IN: "/",
  FORGOT_PASSWORD: "/forgotpassword",
  RESET_PASSWORD: "/resetpassword",
  DASHBOARD: "/admin",
  MANAGE_CHALLENGES: "/admin/manage-challenges",
  USER_CHALLENGE_ACTIVITY: "/admin/user-challenge-activity",
  NOTIFICATIONS: "/admin/notifications",
};
export default ROUTES_PATH;
